import React from "react";

export default function HomeSmallLogo() {
  return (
    <React.Fragment>
      {/*<svg width="497" height="730" viewBox="0 0 497 730" fill="none" xmlns="http://www.w3.org/2000/svg">*/}
      <svg
        viewBox="0 0 497 730"
        className="home-small-logo"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M371.271 0.775024C439.369 0.775024 496.024 57.8331 496.135 125.931C496.311 232.861 496.811 370.935 496.432 384.037C494.958 434.885 469.203 479.803 412.317 516.539C364.363 547.454 316.061 578.204 267.326 608.625C256.227 615.544 251.197 622.628 251.371 632.622C252.064 678.733 251.718 724.845 251.717 770.901C251.717 770.925 251.737 770.944 251.761 770.944C251.785 770.944 251.804 770.956 251.804 770.98C251.804 804.504 251.299 1014.33 251.198 1154.66C251.149 1222.63 195.808 1278.1 127.837 1278.1C58.5115 1278.1 0.990764 1220.4 0.767887 1151.07C0.372932 1028.22 -0.36853 859.186 0.758896 844.087C4.31429 796.918 29.2887 754.855 82.0126 720.59C127.799 690.883 173.846 661.286 221.28 632.677C238.883 622.024 246.168 611.151 245.907 595.666C245.129 527.355 248.912 279.451 250.613 120.646C251.322 54.5598 305.181 0.775024 371.271 0.775024Z"
          fill="url(#paint0_linear_3967_420)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3967_420"
            x1="133.898"
            y1="1114.73"
            x2="263.415"
            y2="72.9051"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0000F5" />
            <stop offset="1" stopColor="#41E58F" stopOpacity="0.13" />
          </linearGradient>
        </defs>
      </svg>
    </React.Fragment>
  );
}
